import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TypographyLayout } from "./TypographyLayout";
import { useGetFirebaseStore } from "../../service/hooks/useGetFirebaseStore";
import { workPath } from "../../utils/workRoutes";
import { SiteHeader } from "./SiteHeader";
import Preloader from "./Preloader";
import "./LandingGrid.css";
import "./Works.css";

const categories = [
  { name: "Film & Doc", key: "documentary" },
  { name: "Branded Content", key: "commercial" },
  { name: "Press", key: "press" },
  { name: "Lunatik", key: "lunatik" },
];

const Works = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const categoryFromParams = queryParams.get("category");
  const initialIndex = Math.max(
    0,
    categories.findIndex((cat) => cat.key === categoryFromParams)
  );
  const initialCategory = categories[initialIndex]?.key || "documentary";

  const [tabIndex, setTabIndex] = useState(initialIndex);
  const [category, setCategory] = useState(initialCategory);
  const { data, loading: dataLoading } = useGetFirebaseStore(category);

  useEffect(() => {
    if (categoryFromParams) {
      const index = categories.findIndex(
        (cat) => cat.key === categoryFromParams
      );
      if (index !== -1) {
        setCategory(categoryFromParams);
        setTabIndex(index);
      }
    }
  }, [categoryFromParams]);

  const handleCategoryChange = (newCategory, index) => {
    if (newCategory === category) return;
    setCategory(newCategory);
    setTabIndex(index);
    navigate(`/works?category=${newCategory}`, { replace: true });
  };

  return (
    <div className="lg-page works-page">
      <SiteHeader />

      <nav className="works-filters" aria-label="Work categories">
        {categories.map((cat, index) => (
          <button
            key={cat.key}
            type="button"
            className={`works-filter${tabIndex === index ? " is-active" : ""}`}
            onClick={() => handleCategoryChange(cat.key, index)}
          >
            {cat.name}
          </button>
        ))}
      </nav>

      <div className="works-stage">
        {dataLoading && (
          <div className="works-preloader">
            <Preloader />
          </div>
        )}
        <TypographyLayout
          data={data}
          tabIndex={tabIndex}
          category={category}
          onOpen={(item) => navigate(workPath(category, item.id))}
        />
      </div>
    </div>
  );
};

export default Works;
